 <template>
  <div class="right">
    <RightTop @data="getCreditDataFn"></RightTop>

    <div class="rightCenter">
      <div class="centerTit">主要流通股东</div>
      <div class="centerCon">
        <div class="no">
          <span>截止日期：</span>
          <el-select
            @change="deadlineFun(selectDate.value)"
            v-model="selectDate.value"
            size="small"
            placeholder="请选择"
          >
            <el-option
              v-for="item in selectDate.deadline"
              :key="item.closeDate"
              :label="item.closeDate"
              :value="item.closeDate"
            ></el-option>
          </el-select>
        </div>
        <div class="excel" @click="downloadTable()">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <!-- 表格纵列 -->
        <div class="tabulationTop">
          <div class="tabulationTopTitle">
            <table>
              <tr>
                <th>截止日期</th>
              </tr>
              <tr>
                <th>公告日期</th>
              </tr>
            </table>
          </div>
          <div class="con">
            <table>
              <!-- 截止日期 -->
              <tr>
                <td>{{closingDate}}</td>
              </tr>
              <!-- 公告日期 -->
              <tr>
                <td>{{announcementDate}}</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 下部横向 -->
        <div class="tabulationBottom">
          <el-table :data="circulateList" style="width: 100%" border size="mini">
            <el-table-column label="序号" width="140">
              <template slot-scope="scope">{{scope.$index+1}}</template>
            </el-table-column>
            <af-table-column prop="shareholderName" label="股东名称"></af-table-column>
            <af-table-column prop="shareholdersNumber" label="本期持有股(股)"></af-table-column>
            <af-table-column prop="shareholdingRatio" label="持有比例(%)"></af-table-column>
            <af-table-column prop="capitalStockNature" label="股份类型"></af-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import RightTop from "@/components/rightTop.vue";

export default {
  props: {},
  components: {
    RightTop
  },
  data() {
    return {
      // 日期
      selectDate: {
        value: "",
        deadline: []
      },

      stockCode: "",
      enterpriseCode: "",

      closingDate: "",
      announcementDate: "",

      liquidityShareholdersCode: "",
      shareholderName: "",
      shareholdersNumber: "",
      shareholdingRatio: "",
      capitalStockNature: "",

      circulateList: []
    };
  },
  computed: {},
  methods: {
    //   获取头部数据
    getCreditDataFn(data) {
      this.stockCode = data[0].companyStockCode;
      this.enterpriseCode = data[0].enterpriseCode;
      // console.log(data, 999999999999);
      this.first();
    },

    // 下载
    downloadTable() {
      this.download(
        window.baseUrl +
          "/capitalStructure/downTequityLiquidityData?stockCode=" +
          this.stockCode +
          "&enterpriseCode=" +
          this.enterpriseCode +
          "&endDate=" +
          this.selectDate.value
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(url) {
      let a = document.createElement("a");
      a.href = url;
      let _id = Math.random() + Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },

    // 首次渲染
    first() {
      this.geTequityLiquidityDate();
      // setTimeout(() => {
      //   this.geTequityLiquidityData(
      //     this.stockCode,
      //     this.enterpriseCode,
      //     this.selectDate.value
      //   );
      // }, 900);
    },
    // 点击select,传值
    deadlineFun(val) {
      this.geTequityLiquidityData(this.stockCode, this.enterpriseCode, val);
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    // 截止日期
    geTequityLiquidityDate() {
      api.stockCirculateDate(this.stockCode, this.enterpriseCode).then(res => {
        this.selectDate.deadline = res.data;
        this.selectDate.value = res.data[0];
        this.geTequityLiquidityData(
          this.stockCode,
          this.enterpriseCode,
          this.selectDate.value
        );
      });
    },
    // 表格数据
    geTequityLiquidityData(stockCode, enterpriseCode, endDate) {
      api.stockCirculate(stockCode, enterpriseCode, endDate).then(res => {
        this.closingDate = res.data.data[0].closingDate;
        this.announcementDate = res.data.data[0].announcementDate;

        this.liquidityShareholdersCode =
          res.data.data[0].liquidityShareholdersCode;
        this.shareholderName = res.data.data[0].shareholderName;
        this.shareholdersNumber = res.data.data[0].shareholdersNumber;
        this.shareholdingRatio = res.data.data[0].shareholdingRatio;
        this.capitalStockNature = res.data.data[0].capitalStockNature;

        this.circulateList = res.data.data;
      });
    }
  },
  created() {},
  mounted() {
    // this.first();
    this.geTequityLiquidityDate(); //日期
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";

// /deep/ .el-table--border td,
// .el-table--border th {
//   border-right: 1px solid #dfdfdf;
//   border-top: 1px solid #dfdfdf;
// }
// .el-table--border {
//   border-top: 0px solid #fff;
//   border-bottom: 1px solid rgba(223, 223, 223, 1);
//   border-left: 1px solid rgba(223, 223, 223, 1);
//   border-right: 1px solid rgba(223, 223, 223, 1);
// }
// /deep/ .el-table thead {
//   color: #333;
// }
// /deep/ .el-table th > .cell {
//   font-size: 14px;
//   font-weight: bold;
// }
// /deep/ .el-table--border th,
// .el-table--border th.gutter:last-of-type {
//   border-right: 1px solid #dfdfdf;
//   background-color: rgba(247, 247, 247, 1);
// }

.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;

  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        margin-left: 10px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        cursor: pointer;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    padding: 20px 20px 50px 20px;
    .tabulation {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      .tabulationTop {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        .tabulationTopTitle {
          width: 140px;
          table th {
            width: 140px;
            height: 35px;
            line-height: 35px;
            padding-left: 11px;
            vertical-align: middle;
            background-color: #375572;
            border: 1px solid #08396a;
            border-right: 0px solid #08396a;
            font-size: 14px;
            color: #fff;
            font-weight: bold;
          }
        }
        .con {
          flex: 1;
          table {
            width: 100%;
          }
          table td {
            width: 16%;
            height: 35px;
            line-height: 35px;
            border: 1px solid #08396a;
            padding-left: 11px;
            color: #fff;
            // text-align: center;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
/deep/ .el-table th {
  display: table-cell !important; //表头不错位
}
/deep/ .el-table .cell {
  white-space: nowrap; //数据不换行
}
</style>


// WEBPACK FOOTER //
// src/view/stock/circulate.vue